import React from "react";
import ReactDOM from "react-dom/client";
import i18n from "i18next";
import { initReactI18next } from "react-i18next";

import { ampli } from "./ampli";
import { App } from "./App";
import reportWebVitals from "./reportWebVitals";
import { isLoggedIn, logOut, UserContext } from "./setup/context/authContext";
import { initOidc } from "./setup/auth/oidc";
import * as ar from "./translations/ar.json";

// analytics

import "./index.css";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);

ampli.load({
  environment:
    process.env.NODE_ENV === "development" ? "development" : "production",
});

i18n.use(initReactI18next).init({
  resources: {
    ar: {
      translation: ar,
    },
  },
});

i18n.changeLanguage("ar");

const renderApp = () => {
  root.render(
    <React.StrictMode>
      <UserContext.Provider
        value={{
          isLoggedIn: isLoggedIn,
          logOut: logOut,
        }}>
        <App />
      </UserContext.Provider>
    </React.StrictMode>
  );
};

// Save the deep-link the user originally requested before Keycloak redirects
// away. On the callback load the URL will carry OIDC params — skip saving then.
const oidcKeys = ["code", "state", "iss", "session_state", "error"];
const _search = new URLSearchParams(window.location.search);
const _hash = new URLSearchParams(window.location.hash.slice(1));
const isOidcCallback = oidcKeys.some((k) => _search.has(k) || _hash.has(k));

if (!isOidcCallback && window.location.pathname !== "/") {
  sessionStorage.setItem(
    "post_login_redirect",
    window.location.pathname + window.location.search + window.location.hash
  );
}

initOidc()
  .then(() => {
    const redirectTo = sessionStorage.getItem("post_login_redirect");
    if (redirectTo) {
      sessionStorage.removeItem("post_login_redirect");
      window.history.replaceState(null, "", redirectTo);
    }
    renderApp();
  })
  .catch((err) => {
    console.error("[KC] init rejected — error:", err);
    if (isOidcCallback) {
      window.location.replace(window.location.pathname);
    } else {
      renderApp();
    }
  });

reportWebVitals();
